import { UiElementType } from 'classes/UIElementType';
import { NodeConnection } from 'dto/NodeConnection';
import { BaseDto } from 'dto/BaseDto';
import { Editor } from "app/metadata-controls/metadata-controls.component";

export class MetaDataDto extends BaseDto
    {
        Description:string;
        Expression:string;
        Properties:MetaDataPropertyDto[];
        Outputs:NodeConnection[];
        Category:string;
        NodeType:NodeTypes;
        UiElementType:UiElementType;
        Icon:string;
    }

    export class MetaDataPropertyDto
    {
        NestedMetaData:MetaDataDto;

        PropertyName:string;

        PropertyType:string;

        Description:string;

        LabelResource:string;

        Required:boolean;

        AllowExpression:boolean;

        ForceEvaluation:boolean;        
        
        Number:boolean;

        Decimal:boolean;

        MinLength:number;

        MaxLength:number;

        MinValue:number;

        MaxValue:number;

        EnumName:string;

        EnumValues:any[];

        RegexValidations:any[];

        Editor:Editor;

        DefaultValue:any;
    }

    export enum NodeTypes{
        ExpressionNode = 0,
        InputNode = 1,
        SubflowNode = 2,
        GoToNode = 3,
        FlowOutput = 4,
    }

    
  export enum EDITORTYPE{
    EXPRESSION = 0,
    TEXTINPUT = 1,
    NUMBERINPUT = 2,
    CHECKBOX = 3,
    FLOWPICKER = 4,
    NODEPICKER = 5,
    ENUMPICKER = 6,
    COLORINPUT = 7,
    DATEINPUT = 8,
    LOCALDATETIMEINPUT = 9,
    EMAILINPUT = 10,
    MONTHYEARINPUT = 11,
    RANGEINPUT = 12,
    SEARCHINPUT = 13,
    TELEPHONEINPUT = 14,
    TIMEINPUT = 15,
    URLINPUT = 16,
    WEEKINPUT = 17,
  };


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/dto/MetadataDto.ts